let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3ooAX")).then(() => parcelRequire('3UCaN'));